import React, { useState, useEffect } from 'react';
import {
    Box,
    Button,
    TextField,
    Typography,
    CircularProgress,
    Grid,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ImageField from '../../../../components/resturaunt-wineries/ImageField'
import {  getCountry } from '../../../../apis/resturants-winerise';
import { Toast } from "../../../../components/alert";
import { API } from "../../../../apis/constants";
import { useParams, useNavigate } from 'react-router-dom';

const LocationCreateForm = () => {

    const [id, setId] = useState(null);
    const [binaryImage, setBinaryImage] = useState(null);
    const [imageError, setImageError] = useState('');
    const [isLoading, setisLoading] = useState(false);
    const [countrys, setCountries] = useState({});
    const [validationErrors, setValidationErrors] = useState({});
   const navigate = useNavigate();

   useEffect(()=>{
    fetchData();
   },[])
   const locID = useParams().id;
    const fetchData = async () => {
       setisLoading(true);
    const urlParams = new URLSearchParams(window.location.search);

console.log('idFromUrl', locID);
    if (locID && locID !== 'new') {
        setId(locID);
        let resp = await getCountry(`/api/dine/country/${locID}`, 'GET');
        setBinaryImage({preview: resp.icon});
        setFormData({ ...formData, location: resp.name });
        setCountries(resp);
    }
       setisLoading(false);
     };
    const [formData, setFormData] = useState({
        location: '',
        image: null,
    });
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [imagePreview, setImagePreview] = useState(null);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.size > 5 * 1024 * 1024) {
                setErrors({ ...errors, image: 'File size must be less than 5MB' });
                setImagePreview(null);
            } else if (!['image/png', 'image/jpeg', 'image/jpg'].includes(file.type)) {
                setErrors({ ...errors, image: 'Only PNG, JPEG, and JPG formats are allowed' });
                setImagePreview(null);
            } else {
                setErrors({ ...errors, image: null });
                setFormData({ ...formData, image: file });
                setImagePreview(URL.createObjectURL(file));
            }
        }
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.location.trim()) {
            newErrors.location = 'Country/State/City is required';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setIsSubmitting(true);
        try {
        const data = new FormData();
        
        if (binaryImage && !binaryImage?.preview) data.append('icon', binaryImage);
              data.append('name', formData.location);
        if(locID && locID !== 'new'){
            data.append('_method', 'PUT');
        }
          const endpoint = locID && locID !== 'new' ? `/api/dine/country/${locID}` : '/api/dine/country';
          await getCountry(endpoint, 'POST', data);
          Toast('success', locID && locID !== 'new' ? 'Location updated successfully' : 'Location created successfully');
        navigate('/resturant-locations');
        } catch (error) {
            console.error('Error submitting form:', error);
            Toast('error', 'Server error, please try again later');
        } finally {
            setIsSubmitting(false);
        }
    };


    return isLoading ? (
        <Box
            sx={{
                height: '90dvh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <CircularProgress />
        </Box>
    ) : (
        <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
                height: '90dvh',
                margin: 'auto',
                display: 'flex',
                flexDirection: 'column',
                padding: 3,
                borderRadius: 2,
                position: 'relative',
            }}
        >
            <Button
                variant="outlined"
                color="primary"
                sx={{
                    position: 'absolute',
                    top: 16,
                    left: 16,
                    '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.1)', // Adjust to a darker shade
                    },
                }}
                onClick={() => navigate('/resturant-locations')}
                startIcon={<ArrowBackIcon />}
            >
                Back
            </Button>

            <Box>
                <Typography variant="h5" component="h1" textAlign="center">
                    {locID && locID !== 'new' ? 'Update Location' : 'Create Location'}
                </Typography>
            </Box>

            <TextField
                sx={{ marginTop: 2 }}
                label="Country/State/City"
                name="location"
                value={formData.location}
                onChange={handleInputChange}
                error={!!errors.location}
                helperText={errors.location}
                fullWidth
            />

            <ImageField 
                height={400}
                widt={600}
                label="Upload Country Image"
                type="restaurant"
                RestaurantId={id}
                binaryImage={binaryImage ? binaryImage : ''}
                errorProp={validationErrors.image}
                onChange={(data, error) => {
                    if (error) {
                        setImageError(error);
                        setBinaryImage(null);
                    } else {
                        setImageError('');
                        setBinaryImage(data.file);
                    }
                }}
            />

            <Box
                sx={{
                    position: 'absolute',
                    bottom: 16,
                    left: 0,
                    right: 0,
                    padding: 2,
                }}
            >
                <Button
                    sx={{
                        backgroundColor: '#C84B96',
                        color: '#fff',
                        borderRadius: 2,
                        textTransform: 'capitalize',
                        '&:hover': {
                            backgroundColor: '#9B3A73', // Darker shade of the current color
                        },
                    }}
                    type="submit"
                    fullWidth
                    disabled={isSubmitting}
                    startIcon={isSubmitting && <CircularProgress size={20} />}
                >
                    {isSubmitting ? 'Submitting...' : 'Submit'}
                </Button>
            </Box>
        </Box>
    );
};

export default LocationCreateForm;